<template>
  <player v-bind="baseProps" @ready="onReady"> </player>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useVisitStore } from "@/store/visit";
import { useModalStore } from "@/store/modal";
import Player from "@/components/player/index.vue";
import { amplitudeTrack } from "@/utils/amplitude";
import type { default as VideoJsPlayer } from "video.js/dist/types/player";

defineOptions({
  name: "blog-player",
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  source: {
    type: String,
    required: true,
  },
  poster: {
    type: String,
    required: true,
  },
  previewDuration: {
    type: String,
    required: true,
  },
  campaign: {
    type: String,
    required: true,
  },
});

const router = useRouter();
const route = useRoute();

const visitStore = useVisitStore();
const modalStore = useModalStore();

// Computed properties
const baseProps = computed(() => {
  return {
    id: props.id,
    poster: props.poster,
    source: props.source,
    sourceType: "video/mp4",
    ratio: "16x9",
  };
});

// Methods
function onReady(player: VideoJsPlayer) {
  player.on("timeupdate", async () => {
    if (!props.previewDuration) {
      return;
    }

    const previewDuration = parseInt(props.previewDuration);
    const currentTime = player.currentTime();

    if (typeof currentTime === "number" && currentTime >= previewDuration) {
      player.currentTime(previewDuration - 1);
      player.pause();

      amplitudeTrack("Limited video stopped");

      await router.replace({
        ...route,
        ...{ query: { w: props.campaign }, hash: "#" },
      });
      visitStore.trackVisit();

      modalStore.showModal({ id: "modal-signup" });
    }
  });
}
</script>
